import { Waypoint } from 'react-waypoint';

const loadMoreContent = ({ fetching, exhausted, fetcher }, e) => {
  if (!(fetching || exhausted) && e.previousPosition) {
    fetcher();
  }
};

export const WaypointLoader = (props) => (
  <Waypoint
    onEnter={(e) => loadMoreContent(props, e)}
    scrollableAncestor="window"
  />
);
